module.exports = __webpack_public_path__ + "img/p2-20.7527a42e.png";